<script>
import { defineComponent, onMounted, ref, watch } from "vue";
import { inView } from "motion";
import { useDebounceFn, useWindowSize } from "@vueuse/core";
import {
  buildColorStyles,
  buildFlexStyles,
  buildGridStyles,
  buildMarginStyles,
  buildMaxWidthStyles,
  buildPaddingStyles
} from "../../composables/useStyle";
import { findBreakpointSettings } from "../../composables/useBreakpoints";
import { usePageStore } from "../../store/pageStore";
import { useNuxtApp } from "#imports";
export default defineComponent({
  name: "VoixQuerySlice",
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const root = ref();
    const queryWrapperStyles = ref();
    const queryWrapperClasses = ref([]);
    const pageStore = usePageStore();
    const generateQueryWrapperStyles = () => {
      let theQuerySlice = Object.assign({}, props.element);
      if (props.element.id) {
        theQuerySlice = pageStore.findElement(props.element.id)?.element;
      }
      if (!theQuerySlice)
        return { properties: { settings: {} } };
      let styles = {};
      if (theQuerySlice.properties.settings) {
        const breakpointSettings = findBreakpointSettings(
          theQuerySlice.properties.settings
        );
        if (breakpointSettings) {
          if (breakpointSettings.position)
            styles.position = breakpointSettings.position;
          styles.display = breakpointSettings.displayMode?.toString();
          styles = buildFlexStyles(styles, breakpointSettings);
          styles = buildGridStyles(styles, breakpointSettings);
          styles = buildMaxWidthStyles(styles, breakpointSettings);
          styles = buildMarginStyles(styles, breakpointSettings);
          styles = buildPaddingStyles(styles, breakpointSettings);
          styles = buildColorStyles(styles, breakpointSettings);
        }
      }
      queryWrapperStyles.value = styles;
    };
    generateQueryWrapperStyles();
    const updateQueryWrapperStyles = useDebounceFn(
      generateQueryWrapperStyles,
      10,
      { maxWait: 50 }
    );
    const generateQueryWrapperClasses = () => {
      const classes = {};
      let theQuerySlice = Object.assign({}, props.element);
      if (props.element.id) {
        theQuerySlice = pageStore.findElement(props.element.id)?.element;
      }
      if (!theQuerySlice)
        return { properties: { settings: {} } };
      const breakpointSettings = theQuerySlice.properties.settings ? findBreakpointSettings(
        theQuerySlice.properties.settings
      ) : null;
      if (breakpointSettings)
        classes.container = breakpointSettings.contain;
      return classes;
    };
    const updateQueryWrapperClasses = useDebounceFn(
      generateQueryWrapperClasses,
      10,
      { maxWait: 50 }
    );
    const { width: windowWidth, height: windowHeight } = useWindowSize();
    watch([windowWidth, windowHeight], () => {
      updateQueryWrapperStyles();
      updateQueryWrapperClasses();
    });
    watch(
      props,
      (value) => {
        if (value) {
          queryWrapperStyles.value = generateQueryWrapperStyles();
          queryWrapperClasses.value = generateQueryWrapperClasses();
        }
      },
      { deep: true }
    );
    const setSliceElement = (element) => {
      return element;
    };
    const { $voix } = useNuxtApp();
    const sliceInView = ref(false);
    const countedTheView = ref(false);
    onMounted(() => {
      watch(root, (el) => {
        if (el?.$el) {
          inView(el.$el, () => {
            if (!countedTheView.value)
              $voix.eventBus.emit("voix:slice:viewed", props.element);
            sliceInView.value = true;
            countedTheView.value = true;
            return () => {
              sliceInView.value = false;
            };
          });
        }
      });
    });
    return {
      props,
      root,
      queryWrapperStyles,
      queryWrapperClasses,
      setSliceElement
    };
  }
});
</script>

<template>
  <div
    :id="element.properties.dom_id"
    ref="root"
    :style="queryWrapperStyles"
    :class="queryWrapperClasses"
  >
    <template v-for="(childElement, key) in element.elements" :key="key">
      <VoixSliceLoop :element="childElement" />
    </template>
  </div>
</template>
